/**
 * BlurredSlideAnimation Module
 * IntersectionObserverを使ったブラー付きスライドインアニメーション
 * Animistaベースのアニメーション実装
 */
export default class BlurredSlideAnimation {
  /**
   * コンストラクタ
   * @param {Object} options - 設定オプション
   * @param {string} options.targetClass - 対象要素のクラス名(デフォルト: 'js-animation-blur-slide')
   * @param {string} options.activeClass - アニメーション実行クラス(デフォルト: 'is-animation-blur-slide')
   * @param {number} options.threshold - 閾値(0-1、デフォルト: 0.1 = 10%)
   * @param {string} options.rootMargin - マージン設定(デフォルト: '0px')
   */
  constructor(options = {}) {
    this.targetClass = options.targetClass || 'js-animation-blur-slide';
    this.activeClass = options.activeClass || 'is-animation-blur-slide';
    this.threshold = options.threshold || 0.1;
    this.rootMargin = options.rootMargin || '0px';

    this.observer = null;
    this.init();
  }

  /**
   * 初期化
   */
  init() {
    const targetElms = document.querySelectorAll(`.${this.targetClass}`);

    if (targetElms.length === 0) return;

    // IntersectionObserver の作成
    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      {
        threshold: this.threshold,
        rootMargin: this.rootMargin,
      }
    );

    // 各要素を監視開始
    targetElms.forEach((elm) => {
      this.observer.observe(elm);
    });
  }

  /**
   * 交差判定のコールバック
   * @param {Array} entries - IntersectionObserverEntry の配列
   */
  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 画面に入った
        const target = entry.target;

        // data-delay 属性があれば遅延実行
        const delay = target.dataset.delay ? parseFloat(target.dataset.delay) : 0;

        setTimeout(() => {
          target.classList.add(this.activeClass);
        }, delay * 1000);

        // 一度アニメーションしたら監視を解除(リソース節約)
        this.observer.unobserve(target);
      }
    });
  }

  /**
   * 破棄処理
   */
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
